import React from 'react';
import {StyleSheet, useWindowDimensions} from 'react-native';
import {
  Dialog,
  Portal,
  Button,
  Text,
  useTheme,
} from 'react-native-paper';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {setAppDialogParams} from '../../../store/slices/ui';

export const ChooseDialog = () => {
  const dispatch = useAppDispatch();
  const left = useAppSelector(
    state => state.ui.appDialogOnSelectLeftt,
  );
  const right = useAppSelector(
    state => state.ui.appDialogOnSelectRight,
  );
  const theme = useTheme();
  const {width, height} = useWindowDimensions();
  const visible = useAppSelector(state => state.ui.appDialogVisible);
  const Body = useAppSelector(state => state.ui.appDialogBody);
  const title = useAppSelector(state => state.ui.appDialogTitle);
  const icon = useAppSelector(state => state.ui.appDialogIcon);
  const loading = useAppSelector(state => state.ui.appDialogLoading);
  const close = () =>
    dispatch(
      setAppDialogParams({
        appDialogVisible: false,
        appDialogBody: undefined,
        appDialogControls: undefined,
        appDialogIcon: undefined,
        appDialogTitle: undefined,
        appDialogOnSelectLeftt: undefined,
        appDialogOnSelectRight: undefined,
        appDialogLoading: false,
      }),
    );
  return (
    <Portal>
      <Dialog
        theme={theme}
        style={{
          width: '80%',
          height: 400,
          maxWidth: 400,
          maxHeight: 400,
          left: (width - 400) / 2,
        }}
        onDismiss={close}
        visible={visible}>
        <Dialog.Icon icon={icon as string} />
        <Dialog.Title style={styles.title}>{title}</Dialog.Title>
        {Body && (
          <Dialog.Content>
            {typeof Body === 'string' ? (
              <Text style={{width: '100%', padding: 20}}>{Body}</Text>
            ) : (
              <Body />
            )}
          </Dialog.Content>
        )}
        <Dialog.Actions>
          <Button
            onPress={left || close}
            mode="outlined"
            loading={loading}
            disabled={loading}
            style={{padding: 5}}>
            Disagree
          </Button>
          <Button
            onPress={right}
            mode="outlined"
            loading={loading}
            disabled={loading}
            style={{padding: 5}}>
            Agree
          </Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};

const styles = StyleSheet.create({
  title: {
    textAlign: 'center',
  },
});
